<template>
	<div class="container">	 	
		<div class="tips"> 
		<span 
				:class="{'active': active == index}" 
				v-for="(item,index) in legends" 
				:key="index"
				@click="changeData(index)" >{{item}}</span> 
		<!-- <span>分时</span> -->
		</div>
	<div ref="echarts" class="echarts"></div>
	</div>
</template>

<script> 

import echarts from 'echarts'
export default {
	name: 'echarts',
	data () {
	    return { 
	    	active:0,
	    	legends:['M5','M15','M60'], 
	    	data: [],
	    	dates:[],
	    	result: [],
	    	echarts:{},
	    }
  	},
  	 mounted(){
        this.$nextTick(function() {
            this.changeData(0);  //默认展示M5数据 
            
        })
    },
    beforeDestroy() {
        // 清理echarts实例，防止内存泄漏
        if (this.echarts) {
            this.echarts.dispose();
        }
    },
  	methods:{ 
  		changeData(url){ //点击切换请求数据
  			this.active = url;
  			if(url == 0){
  				this.getGraph('/GetScript/getGraphs3?mKey=0db23143d4a97ef87410700c73775a97&type=LLG&interval=05m&mt=1758178432074'); 
  			}else if(url == 1){
  				this.getGraph('/GetScript/getGraphs3?mKey=0db23143d4a97ef87410700c73775a97&type=LLG&interval=15m&mt=1758178432074');
  			}else if(url == 2){
  				this.getGraph('/GetScript/getGraphs3?mKey=0db23143d4a97ef87410700c73775a97&type=LLG&interval=01h&mt=1758178432074');
  			}
  		}, 
  		getGraph(url){
  			// 清空之前的数据
  			this.dates = [];
  			this.data = [];
  			this.result = [];
  			
  			this.$http.get(url).
			then((res)=>{  
				let list = Object.values(res.list); 
				let processedList = [];
				list.forEach((item)=>{
					this.dates.push(this.timeStampToDate(item[0],'time'));
					// 创建新数组，不修改原始数据
					processedList.push([...item.slice(1)]);
				}) 
				// 转换数据格式：从 [开盘价, 最高价, 最低价, 收盘价] 转换为 [开盘价, 收盘价, 最低价, 最高价]
				this.data = this.convertKLineData(processedList);
				this.getEcharts(); //初始化echarts
			}).catch((error) => {
				console.error('获取图表数据失败:', error);
			})
  		},
  		convertKLineData(data) {
		    // 转换数据格式：原始数据是 [开盘价, 最高价, 最低价, 收盘价] 转换为 [开盘价, 收盘价, 最低价, 最高价]
		    return data.map(item => {
		        if (item.length >= 4) {
		            const [open, high, low, close] = item;
		            // 转换为 ECharts 需要的格式：[开盘价, 收盘价, 最低价, 最高价]
		            return [parseFloat(open), parseFloat(close), parseFloat(low), parseFloat(high)];
		        }
		        return item;
		    });
		},
  		timeStampToDate(timestamp,f) {
	         // 时间戳转日期
	        let md = new Date(parseInt(timestamp));
	        
	        if(f == 'date') {
	            return (md.getFullYear()+'-'+md.getMonth() + 1) + "-" + md.getDate();
	        }else if(f == 'time') {
	            const hours = md.getHours().toString().padStart(2, '0');
	            const minutes = md.getMinutes().toString().padStart(2, '0');
	            return hours + ":" + minutes;
	        } 
	    },

  		calculateMA(dayCount, data) {  
		    this.result = []; // 清空结果数组
		    for (let i = 0, len = data.length; i < len; i++) {
		        if (i < dayCount) {
		            this.result.push('-');
		            continue;
		        }
		        let sum = 0;
		        for (let j = 0; j < dayCount; j++) {
		            sum += data[i - j][1];
		        }
		        this.result.push((sum / dayCount).toFixed(2));
		    } 
		    return this.result;
		},
  		getEcharts(){
  			  
			let colorList = ['#c23531','#2f4554', '#61a0a8', '#d48265', '#91c7ae','#749f83',  '#ca8622', '#bda29a','#6e7074', '#546570', '#c4ccd3'];
			let labelFont = 'bold 12px Sans-serif';
   
 			this.echarts = echarts.init(this.$refs.echarts);
            this.echarts.setOption({
			    animation: true,
			    color: colorList, 
			    tooltip: {
			        trigger: 'axis',
			        axisPointer: { type: 'cross' },
			        backgroundColor: 'rgba(50,50,50,0.9)',
			        textStyle: { color: '#fff' },
			        formatter: (params) => {
			        	if (!params || !params.length) return '';
			        	const p = params[0];
			        	const index = p.dataIndex;
			        	const date = this.dates && this.dates[index] ? this.dates[index] : '';
			        	
			        	// 直接从我们数据源获取正确的数据
			        	const klineData = this.data && this.data[index] ? this.data[index] : [];
			        	const open = klineData[0];
			        	const close = klineData[1];
			        	const low = klineData[2];
			        	const high = klineData[3];
			        	
			        	return [
			        		`时间：${date}`,
			        		`开盘：${open ? open.toFixed(2) : '--'}`,
			        		`收盘：${close ? close.toFixed(2) : '--'}`,
			        		`最低：${low ? low.toFixed(2) : '--'}`,
			        		`最高：${high ? high.toFixed(2) : '--'}`
			        	].join('<br/>');
			        }
			    },
			    
			    dataZoom: [{
			        type: 'inside',
			        xAxisIndex: [0],
			        start: 20,
			        end: 100
			    }],
			    xAxis: {
			        type: 'category',
			        data: this.dates,
			        boundaryGap : false,
			        axisLine: { lineStyle: { color: '#777' } },
			        axisLabel: {
			            show: true,
			            interval: 'auto',
			            rotate: 0,
			            formatter: function (value) {
			            	// value是时间字符串，直接返回
			            	return value;
			            }
			        },
			        min: 'dataMin',
			        max: 'dataMax',
			        axisPointer: {
			            show: true
			        }
			    },
			    yAxis: {
			        scale: true,
			        splitNumber: 2,
			        axisLine: { lineStyle: { color: '#777' } },
			        splitLine: { show: true },
			        axisTick: { show: false },
			        axisLabel: {
			            inside: false,
			            formatter: '{value}'
			        }
			    },
			    grid: {
			        left: 50,
			        right: 20,
			        top: 40,
			        bottom: 50, 
			    },
			    graphic: [{
			        type: 'group',
			        left: 'center',
			        top: 30,
			        width: 300,
			        bounding: 'raw',
			        children: [{
			            id: 'MA5',
			            type: 'text',
			            style: {fill: colorList[1], font: labelFont},
			            left: 0
			        }, {
			            id: 'MA10',
			            type: 'text',
			            style: {fill: colorList[2], font: labelFont},
			            left: 'center'
			        }, {
			            id: 'MA20',
			            type: 'text',
			            style: {fill: colorList[3], font: labelFont},
			            right: 0
			        }]
			    }],
			    series: 
			    [
				     {
				        type: 'candlestick', 
				        data: this.data,
				        itemStyle: {
				            normal: {
				                color: '#ef232a',
				                color0: '#14b143',
				                borderColor: '#ef232a',
				                borderColor0: '#14b143'
				            },
				            emphasis: {
				                color: 'black',
				                color0: '#444',
				                borderColor: 'black',
				                borderColor0: '#444'
				            }
				        }
				    }  
				] 
			});

  		}
  	}
}
</script> 
<style scoped>
	.container{
		padding:0;
	}
	.echarts{
		width:100%;
		height:5.5rem;
	}  
	.tips{
		text-align: center;
		font-size:0;
		margin:.2rem 0;
	}
	.tips span{
		display:inline-block;
		font-size: 0.24rem; 
	    color: #999999;
	    width:1rem;
	    height:.5rem;
	    line-height:.5rem;
	    border:1px solid #e8e8e8;
	    margin-left:.15rem;
	}
	.tips span.active{
		background:#ff5555;
		color:#fff;
	}
	.detail::after{
		left:47%;
		top:-.5rem;
		border-top: .25rem solid transparent;
	    border-left: .25rem solid transparent;
	    border-right: .25rem solid transparent;
	    border-bottom: .25rem solid #f4f4f4;

	}   
</style>



// WEBPACK FOOTER //
// src/components/market/components/KLine.vue